export default __webpack_public_path__ + "static/media/CancelIcon.9062adfc.svg";